import { all, call, put, select, takeLatest } from "redux-saga/effects";
import { normalize, schema } from "normalizr";

import { showError } from "../../utils/sagasErrorHandler";

import { getNormalizersRequest } from "./api";
import { getNormalizersList, setNormalizers } from "./actions";
import { normalizersSelector } from "./selectors";

const normalizersSchema = new schema.Entity("normalizers" , {},{ idAttribute: "code" });
const normalizersListSchema = new schema.Array(normalizersSchema);

export function* getNormalizersWorker() {
    try {
        const { codes } = yield select(normalizersSelector);

        if(!codes.length){
            yield put(setNormalizers({ isLoadingNormalizers: true }));
            const { normalizers } = yield call(getNormalizersRequest);
            const { result, entities } = normalize(normalizers, normalizersListSchema);

            yield put(setNormalizers({
                isLoadingNormalizers: false,
                codes: result,
                normalizers: entities.normalizers
            }));
        }
    } catch (error) {
        yield put(setNormalizers({ isLoadingNormalizers: false }));
        showError(error);
    }
}

export function* normalizersSagas() {
    yield all([
        yield takeLatest(getNormalizersList, getNormalizersWorker)
    ]);
}
